import "./index.css";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { MainLayout } from "./components/main-layout";
import { defaultPath, menuItems } from "./configs/menus";
import { AuthProvider } from "./utils/auth";
import { Id24Provider } from "./drivers/id24/Id24Provider";
import { MainLayoutAgendes } from "./components/main-layout/main-layout-agendes";
import { activitymenuItems } from "./configs/activity-menus";
import { DetailafterscanQrcode } from "./pages/qrcode/components/detail-after-scan-qrcode";
import { MainEvent } from "./pages/confirm-event/main-confirm-event";
import { MainProfile } from "./pages/register-walk-in/main-profile";
import { Draw } from "./pages/lucky-draw/components/draw";
import { PlayLuckyDraw } from "./pages/luckyDraw/play-lucky-draw";

const App = () => {
  const id24Config = {
    refreshTokenIntervalInSeconds: 50,
    resourceApiBaseUrl: `${process.env.REACT_APP_AUTH_URL}`,
  };
  return (
    <>
      <BrowserRouter basename={"/"}>
        <Id24Provider config={id24Config}>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<MainLayout />}>
                <Route index element={<Navigate to="/" replace />} />
                {menuItems.map((x) => (
                  <Route key={x.key} path={x.path} element={<Outlet />}>
                    {x.component}
                  </Route>
                ))}
              </Route>
              <Route path="/activity-agenda/" element={<MainLayoutAgendes basename={"/register/step"} />}>
                <Route index element={<Navigate to="activity-step/:agendaid" replace />} />
                <Route index element={<Navigate to="activity-step/:agendaid/:userid" replace />} />
                <Route index element={<Navigate to="check-in/:agendaid/userid" replace />} />

                <Route index element={<Navigate to="walkin-register/:agendaid" replace />} />
                {activitymenuItems.map((x) => (
                  <Route key={x.key} path={x.path} element={<Outlet />}>
                    {x.component}
                  </Route>
                ))}
              </Route>

              <Route path="/confirm" element={<MainEvent />} />
              <Route path="/checkin" element={<DetailafterscanQrcode />} />
              <Route path="/profile/:userid" element={<MainProfile />} />
              <Route path="/luckydraw/:id" element={<Draw />} />
              <Route path="/playluckydraw" element={<PlayLuckyDraw />} />
              <Route path="*" element={<Navigate to={defaultPath} replace />} />
            </Routes>
          </AuthProvider>
        </Id24Provider>
      </BrowserRouter>
    </>
  );
};

export default App;
